export default {"src":"/_next/static/media/REAL.57fbd579.svg","height":18,"width":18};